import View from './View'

class SplitView extends View {
  constructor() {
    super();
  }

  //=================
  // Getters/Setters
  //=================

  //=================
  // Constants
  //=================
}

export { SplitView as default }
